<template>
    <layout style="z-index: 99999; position: relative;">
        <!-- Start Banner Area -->
        <div class="slider-one rn-section-gapTop">
            <!-- 视频背景 -->
            <video class="banner-video" autoplay muted loop playsinline>
                <source src="@/assets/images/bg/sybj.mp4" type="video/mp4">
            </video>
            <div class="banner-overlay"></div>
            <!-- 代码渐变遮罩（替代图片）：位于视频上方、文字下方，上下深、中间透明；下方渐变探出盒子使过渡自然 -->
            <div class="banner-bg-mask"></div>
            <div class="banner-bg-bottom"></div>

            <div class="container">
                <div class="banner-content">
                    <h2 class="title" data-sal-delay="200" data-sal="slide-up" data-sal-duration="800">
                        Matrix Power
                    </h2>
                    <h3 class="banner-subtitle" data-sal-delay="250" data-sal="slide-up" data-sal-duration="800">
                        <span class="highlight">{{ $t('home.banner_highlight') }}</span>{{ $t('home.banner_future') }}
                    </h3>
                    <p class="slide-disc" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
                        {{ $t('home.banner_desc') }}
                    </p>
                    <button data-sal-delay="300" data-sal="slide-up" data-sal-duration="800" class="routeB">
                        {{ $t('home.explore') }} <span ><img src="@/assets/images/icons/Vector 168.png" alt=""></span>
                    </button>
                </div>
            </div>
        </div>

        <!-- ========== 衍泰量化模块 ========== -->
        <div class="quant-section" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
            <div class="quant-header">
                <h2 class="quant-title">{{ $t('home.quant.title') }}</h2>
                <p class="quant-subtitle">{{ $t('home.quant.subtitle') }}</p>
            </div>

            <div class="quant-body">
                <!-- 左侧：三大投资策略年化收益 -->
                <div class="quant-left">
                    <h3 class="quant-left-title">{{ $t('home.quant.leftTitle') }}</h3>
                    <p class="quant-left-desc">{{ $t('home.quant.leftDesc') }}</p>

                    <div class="quant-stats">
                        <div class="quant-stat">
                            <p class="stat-number">71%</p>
                            <p class="stat-label">{{ $t('home.quant.stat1') }}</p>
                        </div>
                        <div class="quant-stat">
                            <p class="stat-number">24%</p>
                            <p class="stat-label">{{ $t('home.quant.stat2') }}</p>
                        </div>
                        <div class="quant-stat">
                            <p class="stat-number">104%</p>
                            <p class="stat-label">{{ $t('home.quant.stat3') }}</p>
                        </div>
                    </div>

                    <button class="quant-more-btn" @click="routeGo('/blog-single-column')">{{ $t('home.quant.viewDetail') }} <span ><img src="@/assets/images/icons/Vector 168.png" alt=""></span></button>
                </div>

                <!-- 右侧：安全矩阵 -->
                <div class="quant-right">
                    <div class="fee-badge">
                        <p class="fee-number">50%</p>
                        <p class="fee-label">{{ $t('home.quant.feeLabel') }}</p>
                    </div>

                    <div class="security-card">
                        <p class="security-card-title">{{ $t('home.quant.securityTitle') }}</p>
                        <transition-group name="security-flip" tag="ul" class="security-list">
                            <li v-for="(item, index) in securityItems" :key="item.label" class="security-item"
                                :class="'pos-' + index" @click="onSecurityItemClick">
                                <span class="security-icon"><img :src="item.icon" alt=""></span>
                                <span class="security-name">{{ item.label }}</span>
                                <span class="security-value">{{ item.value }}</span>
                            </li>
                        </transition-group>
                    </div>
                </div>
            </div>
        </div>

        <!-- ========== 服务规模模块 ========== -->
        <div class="service-scale-section" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
            <div class="service-header">
                <h2 class="service-title">{{ $t('home.service.title') }}</h2>
                <p class="service-subtitle">{{ $t('home.service.subtitle') }}</p>
            </div>

            <div class="service-body">
                <div class="service-card touch-glow">
                    <div class="service-item" v-for="(item, index) in serviceScaleItems" :key="index">
                        <div class="service-icon-wrapper">
                            <img :src="item.icon" alt="">
                        </div>
                        <div class="service-data">
                            <p class="service-number">{{ item.number }}</p>
                            <p class="service-label">{{ item.label }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ========== 衍泰AI模块 ========== -->
        <div class="ai-section" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
            <div class="ai-header">
                <h2 class="ai-title">{{ $t('home.aiSection.title') }}</h2>
                <p class="ai-subtitle">{{ $t('home.aiSection.subtitle') }}</p>
            </div>

            <div class="ai-body">
                <!-- 左侧：可切换的轮播图 -->
                <div class="ai-carousel touch-glow ">
                    <!-- 装饰元素 -->
                    <div class="decor-top-right"><img src="@/assets/images/icons/组件 100.png" alt=""></div>
                    <div class="decor-bottom-left"><img src="@/assets/images/icons/组件 101.png" alt=""></div>

                    <!-- 卡片切换区 -->
                    <transition name="fade" mode="out-in">
                        <div :key="currentAICardIndex" class="ai-card">
                            <!-- 卡片1：AiGenNext -->
                            <template v-if="currentAICardIndex === 0">
                                <div class="ai-card-header">
                                    <div class="mac-dots"><span class="red"></span><span class="yellow"></span><span class="green"></span></div>
                                    <div class="card-title">AiGenNext</div>
                                    <div class="status"><span class="dot"></span> {{ $t('home.aiSection.running') }}</div>
                                </div>
                                <div class="blue-block">
                                    <div class="big-number">125,430</div>
                                    <div class="small-label">{{ $t('home.aiSection.participants') }}</div>
                                </div>
                                <div class="stats-row">
                                    <div class="stat-box touch-glow ">
                                        <img style="margin: 0 auto;padding-bottom: 10px;" src="@/assets/images/icons/容器 (9).png" alt="">
                                        <div class="stat-val">15%</div>
                                        <div class="stat-label">{{ $t('home.aiSection.targetApr') }}</div>
                                    </div>
                                    <div class="stat-box touch-glow ">
                                        <img style="margin: 0 auto;padding-bottom: 10px;" src="@/assets/images/icons/容器 (10).png" alt="">
                                        <div class="stat-val">8.5K+</div>
                                        <div class="stat-label">{{ $t('home.aiSection.aiAgents') }}</div>
                                    </div>
                                    <div class="stat-box touch-glow ">
                                        <img style="margin: 0 auto;padding-bottom: 10px;" src="@/assets/images/icons/容器 (11).png" alt="">
                                        <div class="stat-val">100%</div>
                                        <div class="stat-label">{{ $t('home.aiSection.aiGenerated') }}</div>
                                    </div>
                                </div>
                            </template>

                            <!-- 卡片2：AI推广引擎 -->
                            <template v-else>
                                <div class="ai-card-header">
                                    <div class="mac-dots"><span class="red"></span><span class="yellow"></span><span class="green"></span></div>
                                    <div class="card-title">{{ $t('home.aiSection.engine') }}</div>
                                    <div class="status"><span class="dot"></span> {{ $t('home.aiSection.running') }}</div>
                                </div>
                                <div class="list-block">
                                    <div class="list-item touch-glow"><span class="ico"><img src="@/assets/images/icons/容器 (12).png" alt=""></span> {{ $t('home.aiSection.l1') }} <span class="val">{{ $t('home.aiSection.l1v') }} <span style="color: #7C3AED;">95%+</span></span></div>
                                    <div class="list-item touch-glow"><span class="ico"><img src="@/assets/images/icons/容器 (13).png" alt=""></span> {{ $t('home.aiSection.l2') }} <span class="val">{{ $t('home.aiSection.l2v') }} <span style="color: #FFD200;">24/7</span></span></div>
                                    <div class="list-item touch-glow"><span class="ico"><img src="@/assets/images/icons/容器 (14).png" alt=""></span> {{ $t('home.aiSection.l3') }} <span class="val">{{ $t('home.aiSection.l3v') }} <span style="color: #6EDCB5;"> 90%+</span></span></div>
                                    <div class="list-item touch-glow"><span class="ico"><img src="@/assets/images/icons/容器 (15).png" alt=""></span> {{ $t('home.aiSection.l4') }} <span class="val">{{ $t('home.aiSection.l4v') }} <span style="color:#91A2FA"> 95%+</span></span></div>
                                </div>
                            </template>

                            <!-- 底部箭头 -->
                            <div class="ai-card-nav">
                                <span class="arrow-btn" @click="prevCard"> &lt; </span>
                                <span class="arrow-btn" @click="nextCard"> &gt; </span>
                            </div>
                        </div>
                    </transition>
                </div>

                <!-- 右侧：文字说明 -->
                <div class="ai-text">
                    <h3>{{ $t('home.aiSection.productsTitle') }}</h3>
                    <p>{{ $t('home.aiSection.productsDesc') }}</p>
                    <button class="ai-more-btn" @click="routeGo('/yantai-ai')">{{ $t('home.quant.viewDetail') }} <span ><img src="@/assets/images/icons/Vector 168.png" alt=""></span></button>
                </div>
            </div>
        </div>

        <!-- ========== 常见问题模块 (卡片式) ========== -->
        <div class="about-us" style="width: 100%" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
            <h2 class="faq-title">{{ $t('home.about') }}</h2>
            <p class="faq-subtitle">{{ $t('home.faqSubtitle') }}</p>
            
            <!-- 绑定修改为通用类 active-white-glow -->
            <div class="accordion-item active-white-glow "  :class="{ 'active-white-glow-tow': item.isOpen }" v-for="(item, index) in accordionList" :key="index" @click="toggleItem(index)">
                <div class="accordion-header">
                    <div class="header-left">
                        <!-- 图标动态绑定，展开后动态变色 -->
                        <div class="icon-box" :style="item.isOpen ? { border: '0.5px solid ' + faqColors[index] } : {}">
                            <img :src="faqIcons[index]" alt="">
                        </div> 
                        <span class="title-text">{{ item.title }}</span>
                    </div>
                    <i class="arrow" :class="{ 'active': item.isOpen }"></i>
                </div>
                <div class="accordion-content" v-show="item.isOpen">
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </div>

        <!-- ========== APP固收产品模块 (新增) ========== -->
        <div class="app-fixed-product-section" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
            <div class="app-fixed-content">
                <h2 class="fixed-title">{{ $t('home.fixed.title') }}</h2>
                <p class="fixed-subtitle">{{ $t('home.fixed.subtitle') }}</p>
                <button class="fixed-btn" @click="routeGo('/blog-col-two')">{{ $t('home.fixed.download') }} <span ><img src="@/assets/images/icons/Vector 168.png" alt=""></span></button>
                <div class="fixed-features">
                    <div class="feature-item">
                        <img src="@/assets/images/icons/容器 (17).png" alt="">
                        <span>{{ $t('home.fixed.feat1') }}</span>
                    </div>
                    <div class="feature-item">
                        <img src="@/assets/images/icons/容器 (18).png" alt="">
                        <span>{{ $t('home.fixed.feat2') }}</span>
                    </div>
                    <div class="feature-item">
                        <img src="@/assets/images/icons/容器 (19).png" alt="">
                        <span>{{ $t('home.fixed.feat3') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 提示框组件 -->
        <div class="custom-toast" v-if="showToast">
            {{ $t('home.notOpen') }}
        </div>

        <!-- End Banner Area -->
        <share-modal />
        <report-modal />
    </layout>
</template>

<script>
import Layout from '../../components/layouts/Layout'
import ExploreLiveCarousel from '@/components/explore/ExploreLiveCarousel'
import ServiceCard from '@/components/service/ServiceCard'
import ProductCard from '@/components/product/ProductCard'
import SalScrollAnimationMixin from '@/mixins/SalScrollAnimationMixin'
import ShareModal from '@/components/modal/ShareModal'
import ReportModal from '@/components/modal/ReportModal'
import ExploreFilter from '@/components/explore/ExploreFilter'
import ServiceStyleOne from '@/components/service/ServiceStyleOne'
import SellerStyleOne from '@/components/seller/SellerStyleOne'
import CollectionStyleOne from '@/components/collection/CollectionStyleOne'
import ExploreNewestItem from '@/components/explore/ExploreNewestItem'
import Roll from '@/components/roll/index'
import Advertisement from './advertisement.vue'
import DynamicKlineChart from './DynamicKlineChart.vue'
import Card from './card'
import img1 from "@/assets/images/icons/icon_home_gongsi@2x.png"
import img2 from "@/assets/images/icons/icon_home_lianghua@2x.png"
import img3 from "@/assets/images/icons/icon_home_app@2x.png"
import img4 from "@/assets/images/icons/icon_home_kefu@2x.png"
import img5 from "@/assets/images/icons/容器 (8).png"
import img6 from "@/assets/images/icons/容器 (7).png"
import img7 from "@/assets/images/icons/容器 (6).png"
// 引入5个常见问题图标
import imgFaq1 from "@/assets/images/icons/组 322.png"
import imgFaq2 from "@/assets/images/icons/组 322 (1).png"
import imgFaq3 from "@/assets/images/icons/组 322 (2).png"
import imgFaq4 from "@/assets/images/icons/组 322 (3).png"
import imgFaq5 from "@/assets/images/icons/组 322 (4).png"

export default {
    name: 'HomePageOne',
    components: {
        ExploreNewestItem,
        CollectionStyleOne,
        SellerStyleOne,
        ServiceStyleOne,
        ExploreFilter,
        ReportModal,
        ShareModal,
        ProductCard,
        ServiceCard,
        ExploreLiveCarousel,
        Roll,
        Layout,
        Advertisement,
        Card,
        DynamicKlineChart
    },
    mixins: [SalScrollAnimationMixin],
    data() {
        return {
            accordionList: [
                { title: this.$t('home.accordion.title1'), content: this.$t('home.accordion.content1'), isOpen: false },
                { title: this.$t('home.accordion.title2'), content: this.$t('home.accordion.content2'), isOpen: false },
                { title: this.$t('home.accordion.title4'), content: this.$t('home.accordion.content4'), isOpen: false },
            ],
            cards: [
                {
                    title: this.$t('home.accordion.title1'),
                    desc: this.$t('home.card.company_intro_one'),
                    img: img1,
                    route: '/about'
                },
                {
                    title: this.$t('home.card.ai_quant'),
                    desc: this.$t('home.card.ai_quant_one'),
                    img: img2,
                    route: '/blog-single-column'
                },
                {
                    title: this.$t('home.card.app_download'),
                    desc: this.$t('home.card.app_download_one'),
                    img: img3,
                    route: '/blog-col-two'
                },
                {
                    title: this.$t('home.card.contact_us'),
                    desc: this.$t('home.card.contact_us_one'),
                    img: img4,
                    route: '/contact'
                }
            ],
            showToast: false,
                securityItems: [
                    { label: this.$t('home.quant.sec1'), value: this.$t('home.quant.sec1Val'), icon: require('@/assets/images/icons/Icon (1).png') },
                    { label: this.$t('home.quant.sec2'), value: this.$t('home.quant.sec2Val'), icon: require('@/assets/images/icons/Icon (2).png') },
                    { label: this.$t('home.quant.sec3'), value: this.$t('home.quant.sec3Val'), icon: require('@/assets/images/icons/Icon (3).png') },
                    { label: this.$t('home.quant.sec4'), value: this.$t('home.quant.sec4Val'), icon: require('@/assets/images/icons/Icon (4).png') }
                ],
            serviceScaleItems: [
                { icon: img5, number: '200+', label: this.$t('home.service.item1') },
                { icon: img6, number: this.$t('home.service.num2'), label: this.$t('home.service.item2') },
                { icon: img7, number: this.$t('home.service.num3'), label: this.$t('home.service.item3') }
            ],
            currentAICardIndex: 0,
            faqIcons: [imgFaq1, imgFaq2, imgFaq3, imgFaq4, imgFaq5],
            faqColors: ['#165DFF', '#00B42A', '#FF7D00', '#165DFF', '#FFD200']
        };
    },
    methods: {
        toggleItem(index) {
            this.accordionList[index].isOpen = !this.accordionList[index].isOpen;
        },
        routeGo(route) {
            this.$router.push(route);
        },
        showTip() {
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 3000);
        },
        onSecurityItemClick() {
            const items = [...this.securityItems];
            const first = items.shift();
            items.push(first);
            this.securityItems = items;
        },
        nextCard() {
            this.currentAICardIndex = (this.currentAICardIndex + 1) % 2;
        },
        prevCard() {
            this.currentAICardIndex = (this.currentAICardIndex - 1 + 2) % 2;
        }
    }
}
</script>

<style scoped lang="scss">
/* ========== 原有通用样式 ========== */
.touch-glow {
    transition: all 0.3s ease;
}
.touch-glow:hover {
    border: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.2);
  
}
.view-more-section {
    padding: 3vw 2vw;
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    max-width: 1440px;
    margin: 0 auto;
}

.section-title {
    text-align: center;
    margin-bottom: 2.5vw;
    font-weight: 600;
}

.card-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 2vw;
}

.info-card {
    flex: 1;
    min-width: 280px;
    max-width: calc(25% - 1.5vw);
    border: 1px solid #363636;
    border-radius: 0.8vw;
    padding: 2vw;
    height: 300px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    &:hover {
        border-color: #ffc107;
        transform: translateY(-0.5vw);
    }
}

.card-icon {
    .icon-placeholder {
        width: 5vw;
        height: 5vw;
        border-radius: 50%;
        background-color: rgba(255, 193, 7, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1vw;
        &::after {
            color: #ffc107;
            font-size: 2vw;
        }
    }
    .icon-1::after { content: '🏢'; }
    .icon-2::after { content: '🤖'; }
    .icon-3::after { content: '📱'; }
    .icon-4::after { content: '📞'; }
}

.card-title {
    font-size: 1.5vw;
    margin-bottom: 0.8vw;
    font-weight: 500;
    margin-top: 8px;
}

.card-desc {
    font-size: 1vw;
    color: #ccc;
    line-height: 1.5;
    margin-top: 16px;
    margin-bottom: 50px;
}

.card-link {
    font-size: 16px;
    color: #ffc107;
    text-decoration: none;
    transition: color 0.3s;
    display: flex;
    align-items: center;
    height: 30px;
    line-height: 30px;
    &:hover { color: #ffd54f; }
}

@media (max-width: 850px) {
    .data-item { margin: 0 auto; }
    .section-title { font-size: 24px; margin-bottom: 20px; }
    .card-container { flex-direction: column; gap: 15px; }
    .info-card { max-width: 100%; padding: 15px; min-width: auto; }
    .card-icon .icon-placeholder { width: 40px; height: 40px; &::after { font-size: 18px; } }
    .card-title { font-size: 16px; margin-bottom: 8px; }
    .card-desc { font-size: 13px; margin-bottom: 15px; }
    .card-link { font-size: 13px; }
}

@media (min-width: 769px) and (max-width: 1440px) {
    .info-card { max-width: calc(50% - 1vw); }
}

.my-custom-carousel :deep(.slide-content) {
    width: 100%;
    height: 300px;
    padding: 20px;
    text-align: center;
}
.my-custom-carousel :deep(.slide-1) { background-color: #ffeb3b; }
.my-custom-carousel :deep(.slide-2) { background-color: #4caf50; color: white; }
.my-custom-carousel :deep(.slide-3) { background-color: #2196f3; color: white; }

.app-promo-section {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 60px 40px;
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    max-width: 1440px;
    flex-wrap: wrap;
    margin: 0 auto;

    .visual-area {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .phone-container {
            z-index: 2;
            position: relative;
            .phone-screen { width: 580px; height: auto; border-radius: 30px; }
        }
        .decorative-elements {
            position: absolute;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            .coin { position: absolute; width: 80px; height: auto; opacity: 0.8; transition: transform 0.3s ease; &:hover { transform: scale(1.05); } }
            .dollar-coin { bottom: 40px; left: -40px; }
            .gold-coin { top: 60px; right: -30px; width: 60px; }
        }
        .font-size-tag {
            position: absolute; left: -60px; top: 50%; transform: translateY(-50%);
            background-color: #e91e63; color: #fff; font-size: 12px; padding: 4px 8px; border-radius: 4px;
        }
    }

    .text-action-area {
        .main-title { font-size: 48px; line-height: 1.4; margin-bottom: 20px; display: flex; width: 600px; max-width: 80vw; flex-wrap: wrap; .highlight { color: #ffc107; } }
        .desc { font-size: 14px; color: #ccc; line-height: 1.6; margin-bottom: 30px; max-width: 400px; }
        .download-buttons {
            display: flex; gap: 20px;
            .btn { display: flex; align-items: center; justify-content: center; padding: 12px 24px; font-size: 16px; font-weight: 500; height: 48px; border-radius: 6px; cursor: pointer; transition: all 0.3s ease; }
            .android-btn { background-color: #FFD200; color: #212121; border: 1px solid #FFD200; &:hover { background-color: #FFD200; border-color: #FFD200; } }
            .ios-btn { background-color: transparent; color: #FFD200; border: 1px solid #FFD200; &:hover { background-color: rgba(255, 193, 7, 0.1); } }
        }
    }
}

/* ========== 衍泰量化模块样式 ========== */
.quant-section {
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    max-width: 1400px;
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 100px;
    padding: 0 20px;
    box-sizing: border-box;
}

.quant-header {
    text-align: center;
    margin-bottom: 80px;
    .quant-title { font-size: 42px; font-weight: 700; margin-bottom: 16px; }
    .quant-subtitle { font-size: 16px; color: rgba(255, 255, 255, 0.65); }
}

.quant-body { display: flex; align-items: flex-start; gap: 80px; }

.quant-left {
    flex: 1.1;
    padding-top: 40px;
    .quant-left-title { font-size: 28px; font-weight: 700; margin-bottom: 16px; }
    .quant-left-desc { font-size: 14px; color: rgba(255, 255, 255, 0.65); max-width: 460px; line-height: 1.7; margin-bottom: 60px; }
    .quant-stats {
        display: flex;
        margin-bottom: 70px;
        .quant-stat {
            flex: 1; padding: 0 30px; border-right: 1px solid rgba(255, 255, 255, 0.15);
            &:first-child { padding-left: 0; }
            &:last-child { border-right: none; }
            .stat-number { font-size: 44px; font-weight: 700; color: #FFD200; margin-bottom: 12px; }
            .stat-label { font-size: 14px; color: rgba(255, 255, 255, 0.65); }
        }
    }
    .quant-more-btn {
        display: inline-flex; align-items: center; gap: 6px; padding: 12px 20px; text-align: center;
        width: 130px; background: #FFD200; border: none; border-radius: 24px; color: #fff; font-size: 15px;
        font-weight: 600; cursor: pointer; transition: all 0.3s ease;
        .arrow { font-size: 15px; line-height: 1; }
    }
}

.quant-right {
    flex: 1;
    position: relative;
    padding-top: 10px;
    padding-right: 100px;
    background-image: url('~@/assets/images/bg/Abstract Design.png');
    background-size: cover;       
    border-radius: 8px;             
    
    .fee-badge {
        position: relative; z-index: 2; top: 10px; display: inline-block; margin-left: -30px; margin-bottom: -74px;
        background: rgba(26, 31, 46, 0.8); box-sizing: border-box; border: 1px solid rgba(134, 144, 156, 0.6);
        border-radius: 8.26px; padding: 14px 28px; text-align: center; cursor: pointer; transition: all 0.3s ease;
        &:hover { box-shadow: 0 0 25px rgba(255, 255, 255, 0.4); }
        .fee-number { font-size: 24px; font-weight: 700; color: #FFFFFF; }
        .fee-label { font-size: 12px; color: rgba(255, 255, 255, 0.65); margin-top: 4px; }
    }

    .security-card {
        position: relative; z-index: 1; padding: 30px; cursor: pointer; transition: all 0.3s ease; border-radius: 8.26px;
        background: linear-gradient(236deg, #1a1a1a00 0%, #1a1a1a 39%), #1A1A1A; box-sizing: border-box;
        border: 0.69px solid; border-image: linear-gradient(236deg, #ffd20000 91%, #ffd20033 99%) 0.69;
        &:hover { box-shadow: 0 0 25px rgba(255, 255, 255, 0.4); }
        .security-card-title { font-size: 14px; font-weight: 600; color: #FFFFFF; margin-bottom: 16px; }
        .security-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 10px; }
        .security-item {
            display: flex; align-items: center; gap: 12px; padding: 12px 16px; border-radius: 10px; border: 1px solid transparent; cursor: pointer; transition: all 0.4s ease;
            &.pos-0 { background: rgba(255, 255, 255, 0.06); border-color: rgba(255, 255, 255, 0.35); opacity: 1; padding-left: 16px; .security-name { color: #FFFFFF; } .security-value { color: #FFFFFF; font-size: 20px; font-weight: 600; } }
            &.pos-1 { opacity: 0.75; padding-left: 28px; }
            &.pos-2 { opacity: 0.5; padding-left: 40px; }
            &.pos-3 { opacity: 0.3; padding-left: 52px; }
            .security-icon { width: 32px; height: 32px; border-radius: 50%; background: #91A2FA; flex-shrink: 0; display: flex; align-items: center; justify-content: center; img { width: 18px; height: 18px; object-fit: contain; display: block; } }
            .security-name { flex: 1; font-size: 14px; color: rgba(255, 255, 255, 0.85); }
            .security-value { font-size: 16px; color: rgba(255, 255, 255, 0.85); }
        }
    }
}

.security-flip-move { transition: transform 0.5s ease; }

@media (max-width: 992px) {
    .quant-body { flex-direction: column; gap: 60px; }
    .quant-stats .quant-stat .stat-number { font-size: 32px; }
}

@media (max-width: 768px) {
    .quant-header { margin-bottom: 50px; .quant-title { font-size: 30px; } }
    .quant-left { padding-top: 0; .quant-stats { flex-direction: column; gap: 24px; .quant-stat { padding: 0; border-right: none; } } }
}

/* ========== 服务规模模块样式 ========== */
.service-scale-section {
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    max-width: 1400px;
    margin: 0 auto;
    margin-bottom: 100px;
    padding: 0 20px;
    box-sizing: border-box;
}
.service-header { text-align: center; margin-bottom: 60px; }
.service-title { font-size: 42px; font-weight: 700; margin-bottom: 16px; }
.service-subtitle { font-size: 16px; color: rgba(255, 255, 255, 0.65); }
.service-card {
    display: flex; justify-content: space-around; align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 16px; padding: 40px 0;background: rgba(26, 31, 46, 0.8);;
}
.service-item {
    flex: 1; display: flex; align-items: center; justify-content: center; gap: 20px;
    border-right: 1px solid rgba(255, 255, 255, 0.15);
}
.service-item:last-child { border-right: none; }
.service-icon-wrapper { width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.service-data { text-align: left; }
.service-number { font-size: 36px; font-weight: 700; color: #FFD200; margin-bottom: 8px; line-height: 1.2; }
.service-label { font-size: 14px; color: rgba(255, 255, 255, 0.65); }

@media (max-width: 768px) {
    .service-header { margin-bottom: 40px; }
    .service-title { font-size: 30px; }
    .service-card { flex-direction: column; gap: 30px; padding: 20px; }
    .service-item { width: 100%; border-right: none; border-bottom: 1px solid rgba(255, 255, 255, 0.15); justify-content: flex-start; padding-bottom: 20px; }
    .service-item:last-child { border-bottom: none; padding-bottom: 0; }
}

/* ========== 衍泰AI模块样式 ========== */
.ai-section {
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    max-width: 1400px;
    margin: 0 auto;
    margin-bottom: 120px;
    padding: 0 20px;
    box-sizing: border-box;
}
.ai-header { text-align: center; margin-bottom: 60px; }
.ai-title { font-size: 42px; font-weight: 700; margin-bottom: 16px; }
.ai-subtitle { font-size: 16px; color: rgba(255, 255, 255, 0.65); }
.ai-body { display: flex; align-items: center; justify-content: center; gap: 80px; margin-top: 200px; }
.ai-carousel { position: relative; flex: 1.1; max-width: 600px; padding: 30px; background: rgba(26, 31, 46, 0.8); border-radius: 20px; border: 1px solid rgba(255, 255, 255, 0.1); }
.decor-top-right { position: absolute; top: -40px; right: -40px; z-index: 2; }
.decor-bottom-left { position: absolute; bottom: -20px; left: -30px; z-index: 2; }
/* 装饰圆图标 hover 白色阴影（圆形光晕） */
.decor-top-right img,
.decor-bottom-left img { border-radius: 50%; transition: box-shadow 0.3s ease; }
.decor-top-right:hover img,
.decor-bottom-left:hover img { box-shadow: 0 0 25px rgba(255, 255, 255, 0.2); }
.icon-circle, .icon-lightning { display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; border-radius: 50%; font-size: 24px; color: white; background: #007BFF; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3); }
.icon-lightning { background: linear-gradient(135deg, #5B6CFF 0%, #7C4DFF 100%); }

.ai-card { position: relative; z-index: 1; height: 480px; padding: 20px; background: rgba(26, 31, 46, 0.8); border-radius: 16px; }
.ai-card-header { display: flex; align-items: center; margin-bottom: 30px; font-size: 18px; font-weight: 600; }
.mac-dots { display: flex; gap: 6px; margin-right: 20px; }
.mac-dots span { width: 12px; height: 12px; border-radius: 50%; }
.mac-dots .red { background: #FF5F56; }
.mac-dots .yellow { background: #FFBD2E; }
.mac-dots .green { background: #27C93F; }
.card-title { flex: 1; }
.status { font-size: 14px; color: #00FF00; }
.status .dot { display: inline-block; width: 8px; height: 8px; background: #00FF00; border-radius: 50%; margin-right: 5px; }

.blue-block { border-radius: 16px; background: linear-gradient(281deg, #3984f5 -1%, #91a2fa 95%); border-radius: 12px; padding: 15px; margin-bottom: 20px; }
.big-number { font-size: 48px; font-weight: 700; margin-bottom: 8px; }
.small-label { font-size: 14px; opacity: 0.8; }

.stats-row { display: flex; justify-content: space-between; gap: 20px; }
.stat-box { flex: 1; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 12px; padding: 15px; text-align: center; }
.stat-label { font-size: 12px; color: rgba(255, 255, 255, 0.6); margin-bottom: 8px; }
.stat-val { font-size: 24px; font-weight: 700; }

.list-block { display: flex; flex-direction: column; gap: 15px; }
.list-item { display: flex; align-items: center; justify-content: space-between; background: rgba(26, 31, 46, 0.8); border: 1px solid rgba(255, 255, 255, 0.1); padding: 18px 20px; border-radius: 12px; font-size: 15px; }
.list-item .ico { margin-right: 10px; font-size: 18px; }
.list-item .val { color: #86909C; font-weight: 600; }

.ai-card-nav { position: absolute; bottom: 10px; display: flex; justify-content: center; gap: 30px; left: 50%; transform: translateX(-50%); }
.arrow-btn { cursor: pointer; font-size: 20px; color: rgba(255, 255, 255, 0.5); user-select: none; transition: color 0.3s; }
.arrow-btn:hover { color: #FFD200; }

.ai-text { flex: 1; max-width: 450px; }
.ai-text h3 { font-size: 32px; font-weight: 700; margin-bottom: 20px; }
.ai-text p { font-size: 16px; color: rgba(255, 255, 255, 0.65); line-height: 1.8; margin-bottom: 40px; }
.ai-more-btn { width: 150px; display: inline-flex; align-items: center; gap: 6px; padding: 12px 24px; background: #FFD200; border: none; border-radius: 24px; color: #fff; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s ease; }
.ai-more-btn:hover { background: #ffdd33; }
.ai-more-btn .arrow { font-size: 16px; line-height: 1; }

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }

@media (max-width: 992px) {
    .ai-body { flex-direction: column; gap: 60px; }
    .ai-carousel { max-width: 100%; }
}
@media (max-width: 768px) {
    .ai-title { font-size: 30px; }
    .stats-row { flex-direction: column; }
}

/* ========== 常见问题模块样式 (卡片式) ========== */
.about-us {
    color: #ecf0f1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 100px auto;
    max-width: 900px;
}
.faq-title {
    text-align: center;
    margin-bottom: 10px;
    color: #fff;
    font-size: 42px;
    font-weight: 700;
    position: relative;
}
.about-us h2::after { display: none; }
.faq-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 60px;
    text-align: center;
}
/* 提高特异性：覆盖 bootstrap 的 :first-of-type/:last-of-type 0.25rem 圆角，
   否则首尾两张卡（公司介绍/为什么选择衍泰）各有两个角变直角 */
.about-us .accordion-item {
    width: 100%;
    background: rgba(26, 31, 46, 0.8);
    border: 1px solid transparent;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 8px;
    transition: all 0.3s ease;
    overflow: hidden;
}

/* ========== 单独提取的通用白色阴影/发光类 ========== */
.active-white-glow:hover {
    border: 1px solid rgba(255, 255, 255, 0.6);
    /* 已按要求修改为指定的金色加白色混合阴影 */
    box-shadow: 0px 0px 20px 0px rgba(255, 255, 255, 0.2), 0px 0px 20px 0px rgba(255, 210, 0, 0.2);
    transition: all 0.3s ease;
}
.active-white-glow-tow {
    border: 1px solid rgba(255, 255, 255, 0.6);
    /* 已按要求修改为指定的金色加白色混合阴影 */
    box-shadow: 0px 0px 20px 0px rgba(255, 255, 255, 0.2), 0px 0px 20px 0px rgba(255, 210, 0, 0.2);
    background-color: #202020;
    transition: all 0.3s ease;
}


.accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    height: auto;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
}
.header-left {
    display: flex;
    align-items: center;
    gap: 15px;
}
.icon-box {
    width: 40px;
    height: 40px;
    border-radius: 50%; 
    background: rgba(0, 100, 255, 0.15);
    
    /* 关键修复：把 border 拆开写，强制所有边都存在 */
    border-top: 0.5px solid transparent;
    border-bottom: 0.5px solid transparent;
    border-left: 0.5px solid transparent;
    border-right: 0.5px solid transparent;
    
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.3s ease;
}

/* 触摸时强制显示边框颜色，防止透明导致的“border-top: 0”错觉 */
.accordion-item:hover .icon-box {
    border-top: 0.5px solid rgba(255, 255, 255, 0.6);
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.6);
    border-left: 0.5px solid rgba(255, 255, 255, 0.6);
    border-right: 0.5px solid rgba(255, 255, 255, 0.6);
}
.title-text { color: #fff; }
.arrow {
    width: 12px;
    height: 12px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(45deg);
    transition: transform 0.3s ease;
}
.arrow.active { transform: rotate(-135deg); }
.accordion-content {
    padding: 0 30px 25px 85px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    line-height: 1.8;
}

/* ========== 新增：APP固收产品模块样式 ========== */
.app-fixed-product-section {
    position: relative;
    width: 100%;
    /* 背景图片使用您指定的 bg/组 2750.png */
    background-image: url('~@/assets/images/bg/组 2750.png');
    background-size: cover;
    background-position: center;
    padding: 150px 20px;
    color: #fff;
    font-family: 'Microsoft Yahei', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.app-fixed-content { max-width: 600px; width: 100%; }
.fixed-title { font-size: 42px; font-weight: 700; margin-bottom: 16px; }
.fixed-subtitle { font-size: 16px; color: rgba(255, 255, 255, 0.65); margin-bottom: 40px; }
.fixed-btn {
    width: 200px;
    display: inline-flex; align-items: center; justify-content: center; gap: 8px;
    padding: 12px 24px; background: #FFD200; color: #fff;
    border: none; border-radius: 24px; font-size: 16px; font-weight: 600;
    cursor: pointer; transition: all 0.3s ease; margin-bottom: 50px;
}
.fixed-btn:hover { background: #ffdd33; }
.fixed-features { display: flex; justify-content: center; gap: 40px; font-size: 14px; color: rgba(255, 255, 255, 0.85); }
.feature-item { display: flex; align-items: center; gap: 8px; color: rgba(134, 144, 156, 0.8);}
.feature-item :hover { color: #fff; }
.feature-item img { width: 20px; height: 20px; }

/* ========== 基础与 Banner 样式 ========== */
.container { padding: 1.25rem; color: #fff; z-index: 99; position: relative; }
.DynamicKlineChart { position: absolute; top: 100px; z-index: 1; }
.slider-one { position: relative; }
.banner-video { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; z-index: 0; }
            .banner-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(10, 12, 30, 0.45); z-index: 1; }
            .banner-bg-mask { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(180deg, #121620cc 0%, #12162000 25%, #12162000 55%, rgba(18,22,32,.55) 78%, #121620 94%, #121620 100%); z-index: 2; pointer-events: none; }
            .banner-bg-bottom { position: absolute; top: 100%; left: 0; width: 100%; height: 140px; background: linear-gradient(180deg, #121620 0%, #121620 4%, rgba(18,22,32,.6) 28%, rgba(18,22,32,.22) 55%, #12162000 78%); z-index: 2; pointer-events: none; }
            .banner-content { position: relative; z-index: 3; text-align: center; padding: 120px 0 140px; }
.banner-content .title { font-size: 72px; font-weight: 700; color: #FFFFFF; margin-bottom: 16px; letter-spacing: 2px; }
.banner-subtitle { font-size: 70px; font-weight: 700; color: #FFFFFF; margin-bottom: 16px; .highlight { color: #FFD200; } }
.banner-content .slide-disc { font-size: 24px; color: rgba(255, 255, 255, 0.7); margin-bottom: 40px; }
.routeB {  font-size: 20px;display: inline-flex; align-items: center; justify-content: center; gap: 6px; width: auto; min-width: 160px; height: 48px; padding: 0 36px; background: #FFD200; border-radius: 24px; color: #fff; font-weight: 600; .route-arrow { font-size: 16px; line-height: 1; } }

@media (max-width: 768px) {
    .banner-content { padding: 80px 0 90px; }
    .banner-content .title { font-size: 40px; }
    .banner-subtitle { font-size: 24px; }
}

/* ========== 提示框样式 ========== */
.custom-toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 12px 20px;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    border-radius: 4px;
    z-index: 9999;
    font-size: 16px;
    animation: fadeInOut 3s ease-in-out;
}
@keyframes fadeInOut {
    0% { opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { opacity: 0; }
}

/* ========== H5 适配补充（不影响桌面端） ========== */
@media (max-width: 768px) {
    .quant-section { margin-top: 60px; margin-bottom: 60px; }
    .quant-right { padding-right: 0;border-radius: 8px; }

    /* 徽章：桌面是深嵌套选择器，短链会被压制，用同等链长覆盖。
       移动端取消负边距重叠（负边距会把卡片拉上来，
       徽章正好盖住卡片开头的“安全矩阵”标题），改为卡片上方的独立块 */
    .quant-right .fee-badge {
        margin-left: 0;
        margin-bottom: 16px;
    }

    .quant-header .quant-subtitle { font-size: 14px; }

    /* 三个收益数据恢复单行三列，压缩纵向留白 */
    .quant-left .quant-left-desc { margin-bottom: 28px; }
    .quant-left .quant-stats {
        flex-direction: row;
        gap: 0;
        margin-bottom: 36px;
    }
    .quant-left .quant-stats .quant-stat {
        flex: 1;
        padding: 0 10px;
        border-right: none;
    }
    .quant-left .quant-stats .quant-stat:first-child { padding-left: 0; }
    .quant-left .quant-stats .quant-stat .stat-number { font-size: 26px; margin-bottom: 6px; }
    .quant-left .quant-stats .quant-stat .stat-label { font-size: 12px; }

    /* 查看详情按钮：宽度随文案自适应，避免英文/越南语溢出 */
    .quant-left .quant-more-btn {
        width: auto;
        padding: 12px 24px;
    }

    /* 安全矩阵卡片：收窄内边距与阶梯缩进，防止窄屏溢出 */
    .quant-right .security-card { padding: 20px; border-radius: 8px; }
    .quant-right .security-card .security-item { padding: 10px 12px; }
    .quant-right .security-card .security-item.pos-1 { padding-left: 20px; }
    .quant-right .security-card .security-item.pos-2 { padding-left: 30px; }
    .quant-right .security-card .security-item.pos-3 { padding-left: 40px; }
    .quant-right .security-card .security-item .security-value { font-size: 14px; }
    .quant-right .security-card .security-item.pos-0 .security-value { font-size: 17px; }

    .service-scale-section { margin-bottom: 60px; }
    .service-number { font-size: 28px; }

    .ai-section { margin-bottom: 70px; }
    .ai-body { margin-top: 80px; gap: 40px; }
    .decor-top-right,
    .decor-bottom-left { display: none; }
    .ai-carousel { padding: 20px 16px; }
    .ai-card { height: auto; min-height: 420px; padding: 16px; }
    .blue-block { padding: 14px; }
    .big-number { font-size: 34px; }
    .list-item { flex-wrap: wrap; gap: 4px; font-size: 13px; padding: 14px 16px; }
    .ai-text h3 { font-size: 24px; }
    .ai-text p { font-size: 14px; margin-bottom: 24px; }

    .about-us { margin: 60px auto; }
    .faq-title { font-size: 30px; }
    .faq-subtitle { margin-bottom: 30px; }
    .accordion-content { padding: 0 20px 20px 64px; font-size: 14px; }

    .app-fixed-product-section { padding: 80px 16px; }
    .fixed-title { font-size: 30px; }
    .fixed-subtitle { margin-bottom: 28px; }
    .fixed-btn { margin-bottom: 30px; }
    .fixed-features { flex-wrap: wrap; gap: 14px 24px; }
}
</style>